// extracted by mini-css-extract-plugin
export var acceptButton = "cookie-modal-module--accept-button--ySfih";
export var buttons = "cookie-modal-module--buttons--v-QP7";
export var container = "cookie-modal-module--container--3Mgbu";
export var link = "cookie-modal-module--link--U1gWn";
export var rejectButton = "cookie-modal-module--reject-button--HerIM";
export var text = "cookie-modal-module--text--F6ogD";
export var title = "cookie-modal-module--title--X6WlF";